import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Input, List, Tooltip, Spin } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import GetDropdownAttributesApi from "../../api/attributes/GetDropdownAttributesApi";
import CreateDropdownValueApi from "../../api/attributes/CreateDropdownValueApi";
import DeleteDropdownValueApi from "../../api/attributes/DeleteDropdownValueApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import PageLoader from "../../components/sub/PageLoader";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";

function DropdownAttributes() {
  const [loading, setLoading] = useState(true);
  const [attributes, setAttributes] = useState([]);
  const [newValues, setNewValues] = useState({});
  const proHeight = document.body.clientHeight;

  useEffect(() => {
    getDropdownAttributes();
  }, []);

  async function getDropdownAttributes() {
    setLoading(true);
    const apiResponse = await GetDropdownAttributesApi();
    if (apiResponse.success) {
      setAttributes(apiResponse.data);
    }
    setLoading(false);
  }

  async function addDropdownValue(attributeId) {
    const value = newValues[attributeId];
    if (!value || value.trim() === "") {
      openNotificationError("bottomRight", "Please enter a value");
      return;
    }

    const apiResponse = await CreateDropdownValueApi(attributeId, value, 0);
    if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Dropdown value added");
      setNewValues({ ...newValues, [attributeId]: "" });
      getDropdownAttributes();
    } else {
      openNotificationError("bottomRight", apiResponse.message);
    }
  }

  async function deleteDropdownValue(valueId) {
    const apiResponse = await DeleteDropdownValueApi(valueId);
    if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Dropdown value deleted");
      getDropdownAttributes();
    } else {
      openNotificationError("bottomRight", apiResponse.message);
    }
  }

  const left = (
    <div className="text-lg pri-font">
      Dropdown Attributes ({attributes.length})
    </div>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {loading ? (
            <PageLoader />
          ) : attributes.length === 0 ? (
            <div className="text-center text-gray-400 mt-10">
              No dropdown attributes found. Create a plan attribute with type
              "Dropdown" first.
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {attributes.map((attr) => (
                <Card
                  key={attr.id}
                  title={attr.name}
                  extra={
                    <span className="text-xs text-gray-500">
                      {attr.dropdownOptions?.length || 0} options
                    </span>
                  }
                >
                  <List
                    size="small"
                    dataSource={attr.dropdownOptions || []}
                    renderItem={(option) => (
                      <List.Item
                        actions={[
                          <Tooltip title="Delete">
                            <Button
                              type="text"
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() => deleteDropdownValue(option.id)}
                            />
                          </Tooltip>,
                        ]}
                      >
                        {option.value}
                      </List.Item>
                    )}
                  />
                  <div className="mt-3 flex gap-2">
                    <Input
                      placeholder="Add new option"
                      value={newValues[attr.id] || ""}
                      onChange={(e) =>
                        setNewValues({
                          ...newValues,
                          [attr.id]: e.target.value,
                        })
                      }
                      onPressEnter={() => addDropdownValue(attr.id)}
                    />
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => addDropdownValue(attr.id)}
                    >
                      Add
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </Content>
    </>
  );
}

export default DropdownAttributes;
